var primitiveButton = 'fx_e395032e_163p7g20';
var primitiveButtonClickableVariants = {weak:'fx_e395032e_163p7g21','default':'fx_e395032e_163p7g22',strong:'fx_e395032e_163p7g23',none:'fx_e395032e_163p7g24'};

export { primitiveButton, primitiveButtonClickableVariants };
//# sourceMappingURL=primitiveButton.vanilla.mjs.map
